module.exports = __webpack_public_path__ + "img/img_tutorial_identity_verification.93d6991a.svg";